import { type RecommendationProfile } from '@/models/recommendation';
import { Goal } from '@/models/recommendation';
import type { UserJobTitles } from '@/models/taxonomy/job';

export const profileGoalDescription = (
  profile: RecommendationProfile,
  jobs?: UserJobTitles
) => {
  const description = {
    [Goal.CareerDevelopment]: `Evoluir como ${jobs?.current?.name || profile.current_job?.name}`,
    [Goal.CareerChange]: jobs?.desired?.name || profile.desired_job?.name,
  };

  return description[profile.goal ?? Goal.CareerDevelopment];
};
